import RootLayout from "../../components/layout/RootLayout";
import FAQ from "./Faq";
import GetStarted from "./GetStarted";
import Hero from "./Hero";
import Models from "./Models";
import Platform from "./Platform";
import Services from "./Services";
import Stats from "./Stats";
import Why from "./Why";

const Landing = () => {
  return (
    <RootLayout>
      <main>
        <Hero />
        <Services />
        <Stats />
        <Platform />
        <Models />
        <Why />
        <FAQ />
        <GetStarted />
      </main>
    </RootLayout>
  );
};

export default Landing;
